__turbopack_context__.v({
  "annual": "BillingFrequency-module-scss-module__66q0Sa__annual",
  "btn": "BillingFrequency-module-scss-module__66q0Sa__btn",
  "btn-alt": "BillingFrequency-module-scss-module__66q0Sa__btn-alt",
  "btn-default": "BillingFrequency-module-scss-module__66q0Sa__btn-default",
  "btn-default-dark-bg": "BillingFrequency-module-scss-module__66q0Sa__btn-default-dark-bg",
  "btn-disabled": "BillingFrequency-module-scss-module__66q0Sa__btn-disabled",
  "btn-elite": "BillingFrequency-module-scss-module__66q0Sa__btn-elite",
  "btn-gold": "BillingFrequency-module-scss-module__66q0Sa__btn-gold",
  "btn-lg": "BillingFrequency-module-scss-module__66q0Sa__btn-lg",
  "btn-link": "BillingFrequency-module-scss-module__66q0Sa__btn-link",
  "btn-plat": "BillingFrequency-module-scss-module__66q0Sa__btn-plat",
  "btn-primary": "BillingFrequency-module-scss-module__66q0Sa__btn-primary",
  "btn-sm": "BillingFrequency-module-scss-module__66q0Sa__btn-sm",
  "btn-success": "BillingFrequency-module-scss-module__66q0Sa__btn-success",
  "btn-warning": "BillingFrequency-module-scss-module__66q0Sa__btn-warning",
  "disabled": "BillingFrequency-module-scss-module__66q0Sa__disabled",
  "label": "BillingFrequency-module-scss-module__66q0Sa__label",
  "monthly": "BillingFrequency-module-scss-module__66q0Sa__monthly",
  "price": "BillingFrequency-module-scss-module__66q0Sa__price",
  "radioButton": "BillingFrequency-module-scss-module__66q0Sa__radioButton",
  "radioButtonWrapper": "BillingFrequency-module-scss-module__66q0Sa__radioButtonWrapper",
  "savingExplanation": "BillingFrequency-module-scss-module__66q0Sa__savingExplanation",
  "savings": "BillingFrequency-module-scss-module__66q0Sa__savings",
});
